import { EVENT_TOOLTIP } from '../../../hooks/useTracking/events/eventTypes.js';
export const action = payload => {
  return {
    type: EVENT_TOOLTIP,
    payload
  };
};
export const handler = action => {
  return {
    event: 'tooltip',
    ...action.payload,
    event_action: `${action.payload.event_action}`,
    tooltip_element: action.payload.tooltip_element,
    tooltip_text: action.payload.tooltip_text ? action.payload.tooltip_text.slice(0, 100) : undefined
  };
};